import { Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectTriggerAppInit } from '@core/store/selectors/app-init.selectors';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationStart,
  Router,
} from '@angular/router';

@Injectable()
export class AppInitService {
  private appLoading: WritableSignal<boolean> = signal(false);

  constructor(
    private store: Store,
    private router: Router,
  ) {
    this.setLoadingStateOnAppInit();
  }

  get appLoadingState(): Signal<boolean> {
    return this.appLoading;
  }

  // this solution was chosen to reflect app loading state
  // because router waits for all guards to be resolved
  // and basically all async initiation logic is placed in guards
  private setLoadingStateOnAppInit(): void {
    this.router.events.subscribe((event) => {
      const startEvent = event instanceof NavigationStart;
      const stopEvents =
        event instanceof NavigationEnd || event instanceof NavigationCancel;

      if (startEvent) this.appLoading.set(true);
      if (stopEvents) this.appLoading.set(false);
    });
  }

  // This is the method you want to call at bootstrap
  // Important: It should return a Promise
  public init() {
    return this.store.pipe(selectTriggerAppInit).toPromise();
  }
}
